import axios from "axios";

const requestService = {
    login(username, password) {
        const data = new FormData();
        data.append("username", username);
        data.append("password", password);
        return axios.post("/auth/login", data);
    },

    refreshToken(refreshToken) {
        const data = new FormData();
        data.append("refreshToken", refreshToken);
        return axios.post("/auth/refreshToken", data);
    },

    uploadImages(imageArray, recordingType, transectCode, originator, height, comment, dateTimeStart, dateTimeEnd, sessionId) {
        const uploadImageData = new FormData();
        for (let i = 0; i < imageArray.length; i++) {
            let file = imageArray[i];
            uploadImageData.append("files", file, file.name);
        }
        if (dateTimeStart && dateTimeStart != "") {
            uploadImageData.append("dateTimeStart", dateTimeStart);
        }
        if (dateTimeEnd && dateTimeEnd != "") {
            uploadImageData.append("dateTimeEnd", dateTimeEnd);
        }
        uploadImageData.append("originator", originator);
        uploadImageData.append("cameraHeight", height);
        uploadImageData.append("transectCode", transectCode);
        uploadImageData.append("recordingType", recordingType);
        uploadImageData.append("comment", comment);
        uploadImageData.append("sessionId", sessionId);

        return axios.post("/transects/upload", uploadImageData);
    },

    createTransect(recordingType, transectCode, originator, height, comment, dateTimeStart, dateTimeEnd, sessionId) {
        const uploadImageData = new FormData();

        if (dateTimeStart && dateTimeStart != "") {
            uploadImageData.append("dateTimeStart", dateTimeStart);
        }
        if (dateTimeEnd && dateTimeEnd != "") {
            uploadImageData.append("dateTimeEnd", dateTimeEnd);
        }
        uploadImageData.append("originator", originator);
        uploadImageData.append("cameraHeight", height);
        uploadImageData.append("transectCode", transectCode);
        uploadImageData.append("recordingType", recordingType);
        uploadImageData.append("comment", comment);
        uploadImageData.append("sessionId", sessionId);

        return axios.post("/transects", uploadImageData);
    },

    finishSession(transectId, sessionId) {
        const sessionCloseRequest = new FormData();

        sessionCloseRequest.append("transectId", transectId)
        sessionCloseRequest.append("sessionId", sessionId);

        return axios.post("/transects/upload/closeSession", sessionCloseRequest);
    },

    requestUploadSession() {
        return axios.get("/transects/upload/generateSession");
    },

    findAllHeights() {
        return axios.get("/utilities/fetchAllowedHeights");
    },

    findAllTransects() {
        return axios.get("/transects");
    },

    findTransectById(id) {
        return axios.get("/transects/" + id);
    },

    findTransectByTransectCode(transectCode) {
        return axios.get("/transects/fetchWithTransectCode/" + transectCode);
    },

    findTransectPointById(id) {
        return axios.get("/transectpoints/" + id);
    },

    findAllTransectPointsByTransectId(id) {
        return axios.get("/transectpoints/fetchWithTransectId", {
            params: {
                transectId: id
            }
        });
    },

    findAllNotAssignedPicturesByTransectId(id) {
        return axios.get("/pictures/fetchNotAssignedWithTransectId", {
            params: {
                transectId: id
            }
        });
    },

    findPicturesWithTransectPointId(id) {
        return axios.get("/pictures/fetchWithTransectPointId", {
            params: {
                transectPointId: id
            }
        });
    },

    analyzeTransect(id) {
        return axios.post("/transects/" + id + "/startAiAnalyzation");
    },

    cancelAnalyzeTransect(id) {
        return axios.post("/transects/" + id + "/cancelAnalyzation");
    },

    downloadTransect(id) {
        return axios({
            url: '/transects/' + id + '/downloadAiAnalyzationResults',
            method: 'GET',
            responseType: 'arraybuffer',
        })
    },

    deleteTransect(id) {
        return axios.delete("/transects/" + id);
    },

    deletePicture(id) {
        return axios.delete("/pictures/" + id);
    },

    deleteTransectPoint(id) {
        return axios.delete("/transectpoints/" + id);
    },

    analyzeTransectPoint(id) {
        return axios.post("/transectpoints/" + id + "/startAiAnalyzation");
    },

    downloadTransectPoint(id) {
        return axios({
            url: '/transectpoints/' + id + '/downloadAnalyzationResults',
            method: 'GET',
            responseType: 'arraybuffer',
        });
    },

    getAvailableDiskSpace() {
        return axios.get("/utilities/availableDiskSpace");
    },

    downloadTransectPictures(id) {
        return axios({
            method: 'get',
            url: '/transects/' + id + '/downloadImages',
            responseType: "arraybuffer"
        });
    },

    uploadTransectPointMergeTime(time) {
        const data = new FormData();
        data.append("time", time);
        return axios.post("/settings/setMergeTransectPointsTime", data);
    },

    getTransectPointMergeTime() {
        return axios.get("/settings/getMergeTransectPointsTime");
    },

    uploadGpsAcceptance(gpsAcceptance) {
        const data = new FormData();
        data.append("gpsAcceptance", gpsAcceptance);
        return axios.post("/settings/setGpsAcceptance", data);
    },

    getGpsAcceptance() {
        return axios.get("/settings/getGpsAcceptance");
    },

    uploadRemovalTreshold(removalTreshold) {
        const data = new FormData();
        data.append("removalTreshold", removalTreshold);
        return axios.post("/settings/setRemovalTreshold", data);
    },

    getRemovalTreshold() {
        return axios.get("/settings/getRemovalTreshold");
    },

    getDebugMode() {
        return axios.get("/settings/getDebugMode");
    },

    activateDebugMode(password) {
        const data = new FormData();
        data.append("password", password);
        return axios.post("/settings/activateDebugMode", data);
    },

    disableDebugMode() {
        return axios.post("/settings/disableDebugMode");
    },

    syncTransectsInAiAnalyzation(ids) {
        return axios.get("/transects/syncTransectsAiAnalyzation", {
            params: {
                ids: ids.join(',')
            }
        });
    },
// TODO dp https://github.com/axios/axios/issues/5142
// AxiosError{message: 'options must be an object', name: 'AxiosError', code: 'ERR_BAD_OPTION_VALUE', stack: 'AxiosError: options must be an object\n    at Objec…l:///./src/mixins/AnalyzeTransectMixin.js:152:12)'}
    syncTransectsInExifAnalyzation(ids) {
        return axios.get("/transects/syncTransectsExifAnalyzation", {
            params: {
                ids: ids.join(',')
            }
        });
    },

    findAllIncorrectlyPictures() {
        return axios.get("/pictures/fetchNotValidPictures");
    },

    deleteIncorrectlyPicture(id) {
        return axios.delete("/pictures/" + id);
    },

    deleteAllIncorrectlyPictures() {
        return axios.delete("/pictures/notValidPictures");
    },

    generatePasswordResetToken() {
        return axios.post("/passwordReset/generateToken");
    },

    async addPicturesToTransect(id, cameraHeight, imageArray) {
        const uploadImageData = new FormData();
        for (let i = 0; i < imageArray.length; i++) {
            let file = imageArray[i];
            uploadImageData.append("files", file, file.name);
        }

        uploadImageData.append("cameraHeight", cameraHeight);
        uploadImageData.append("transectCode", id);
        uploadImageData.append("recordingType", "top-down");

        let response = await axios.post("/transects/" + id + "/addPictures", uploadImageData);
        return response;
    },

    async associatePicturesToTransectPoint(id) {
        let response = await axios.post("/transects/" + id + "/associatePictures");
        return response;
    },

    resetPassword(newPassword, token) {
        const data = new FormData();
        data.append("password", newPassword);
        data.append("token", token);
        return axios.post("/passwordReset/resetPassword", data);
    },

    validatePassword(password) {
        const data = new FormData();
        data.append("password", password);
        return axios.post("/passwordReset/validatePassword", data);
    },

    loadPicture(pictureId) {
        return axios.get("/pictures/" + pictureId + "/fetchImage");
    }
}

export default requestService